var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('enterprise-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeKey===1),expression:"activeKey===1"}],ref:"list",on:{"add":_vm.add,"edit":_vm.edit}}),_c('enterprise-detail',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeKey===2),expression:"activeKey===2"}],ref:"detail",on:{"back":_vm.back}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }